<banner class="banner"
    [visible]="showConfirmationBanner"
    [message]="fedRampMessage"
    type="confirmation"
    [@expand]
    (yes)="navigateToCloud(selectedCloud)"
    (no)="onConfirmNo()">
</banner>

<div class="clouds-content">
  <h2 class="title">Cloud Instances</h2>
  <div class="container" *ngIf="loaded && !clouds.length">
    <p class="text error">You do not have access to any cloud</p>
  </div>
  <div class="flex-grid">
    <div
      *ngFor="let cloud of clouds"
      class="cloud-card"
      (click)="onCloudClick(cloud)"
    >
      <div class="circle">
        <img class="cloud-icon" src="assets/icons/white_filled_cloud.svg" />
      </div>
      <span class="cloud-card-title"> {{ cloud.Name }} </span>
    </div>
  </div>
  <app-default-loading-icon *ngIf="loading"></app-default-loading-icon>
</div>

